export const API_NOTIFICATION_CONSTANT = {
  sendInvitation: "notification/send-invitation",
  testMessage: "notification/test-message",
  expiryNotification: "notification/expiry",
  checkExpiring: "notification/check-expiring",
} as const;
